import {createActions} from 'client/framework';

export const drawerActions = createActions(null, [
  'DRAWER_RESET_STORE',
  'DRAWER_SET_DRAWER_VISIBILITY'
]);
